import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import "./index.css";
import prepareAppStore from "./redux/store/index";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./Components/Errorboundary";
import { I18nextProvider } from "react-i18next";
import i18next from "./Localization/i18next";

const { store, persistor } = prepareAppStore();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ErrorBoundary>
          <I18nextProvider i18n={i18next}>
            <App />
          </I18nextProvider>
        </ErrorBoundary>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
